export default __webpack_public_path__ + "static/demographics1-4f8d8b725bb0326916ee4caf711ba5f9.png";